@if (safeUrl) {
  <iframe class="iframe-lg" title="Navigation map" [src]="safeUrl" id="map"></iframe>
}
<!--<div #mapContainer id="map" class="iframe-lg"></div>-->